import { RequestOptions } from './request-options';

export class FoodRequestOptions extends RequestOptions {
    Id_Profile: number;
    IsShort: number;
    IsExcluded: number;
    IsFavorite: number;
    Name: string;
    FullName: string;
    Id_Product: number;
    NWeek: number;
    FullList: number;
    id_product: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/food-request-options.ts